module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/snapchat-ghost-3aad92eb894fc891a46965d15163f350.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/snapchat-ghost.svg
// module id = KXBh
// module chunks = 24